// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./src/jquery"
import "./src/sentry" // Initialize Sentry early for error tracking
import "./src/custom"
import "./controllers"
import * as bootstrap from "bootstrap"
require('select2')()
import "flatpickr"
import "slick-carousel"
import "@nathanvda/cocoon"
import 'datatables.net'
import "trix"
import "@rails/actiontext"
import "chartkick/chart.js"
// Note: When creating new Stimulus controllers, run `rails stimulus:manifest:update` to register them

import "./channels"
